<template>
  <div style="margin: 20px">
    取消绑定后需要重新绑定，教职工需要重新认证，是否确定？
    <br>
    <br>
    注意：删除绑定会将服务器所有已同步设备的绑定全部删除，同时清空所有选座。如果只想删除本设备的绑定，请点击下方的 “取消本设备的绑定”
    <br>
    <el-button v-if="!confirm" type="danger" style="margin: 20px" plain @click="confirm=true;confirm1=false">取消绑定
    </el-button>
    <el-button v-if="confirm" type="danger" style="margin: 20px" plain @click="onSubmit">确定取消绑定</el-button>

    <br>
    <el-button v-if="!confirm1" type="danger" style="margin: 20px" plain @click="confirm1=true;confirm=false">取消本设备绑定
    </el-button>
    <el-button v-if="confirm1" type="danger" style="margin: 20px" plain @click="onCancelThisDevice">确定取消本设备绑定
    </el-button>

  </div>


</template>

<script>
import axios from '@/utils/request'
import {setToken, getToken} from '@/utils/auth'

export default {
  name: 'Home',
  data() {
    return {
      confirm: false,
      confirm1: false

    }
  },
  methods: {
    onSubmit() {
      axios.post("/cancelBind").then(() => {
        this.$router.push("/")
        setToken("")
      })
    },
    onCancelThisDevice() {
      setToken("")
      this.$router.push("/")
      this.$notify({
        type: 'success',
        message: '取消绑定成功',
        duration: 2 * 1000,
        position: "bottom-right"
      })
    }
  },
  mounted() {
    this.confirm = false
    this.confirm1 = false

  },
  created() {
    // axios.post("/getBindInfo").then(res => {
    //   if (res.data.Bind === "true") {
    //     setTimeout(() => {
    //       this.loading = false
    //       this.form.name = res.data.name
    //       this.form.xh = res.data.xh
    //       this.form.nickName = res.data.nickname
    //     }, 500)
    //
    //   } else {
    //     this.loading = false
    //   }


    // }
    // )
  }

}
</script>

<style scoped>
img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}


</style>
